import { Link } from 'gatsby';
import { DateTime } from 'luxon';
import { ButtonUnstyled, useDrawer } from '@lambdacurry/component-library';
import { StripePaymentMethod, SubscriptionFrequency, SubscriptionOrder } from 'lib/home/generated/types/api';
import { BottomToRightDrawer } from '../BottomToRightDrawer/BottomToRightDrawer';
import { CartPriceBreakdown } from '../../Cart';
import { formatDate } from 'lib/util/date';
import './box-price-breakdown.scss';

export interface BoxPriceBreakdownDrawerData {
  currentOrder: SubscriptionOrder;
  defaultPaymentMethod: StripePaymentMethod;
  frequency: SubscriptionFrequency;
}

export const BoxPriceBreakdownDrawer = () => {
  const {
    drawerActions: { getDrawerData }
  } = useDrawer();

  const { currentOrder, defaultPaymentMethod, frequency } =
    getDrawerData<BoxPriceBreakdownDrawerData>('box-price-breakdown');

  const complete_order_at = currentOrder?.complete_order_at;
  const medusa_cart = currentOrder?.medusa_cart;
  const nextPaymentDate = formatDate(DateTime.fromISO(complete_order_at));

  return (
    <BottomToRightDrawer className="box-price-breakdown-drawer" name="box-price-breakdown">
      <h2 className="mt-3">Price Breakdown</h2>
      <CartPriceBreakdown cart={medusa_cart} subscriptionFrequency={frequency} />

      <hr />

      <div className="mt-10">
        <p className="my-1">
          Next Payment: <b>{nextPaymentDate}</b>
        </p>
        <p className="my-1 uppercase font-bold">
          {defaultPaymentMethod?.card.brand} {defaultPaymentMethod?.card.last4}
        </p>
        <ButtonUnstyled
          as={buttonProps => <Link {...buttonProps} className="my-1 !underline" to="/account/payment-methods" />}
        >
          Change payment method
        </ButtonUnstyled>
      </div>
    </BottomToRightDrawer>
  );
};
